module.exports = __webpack_public_path__ + "img/symbol_12.7e08ef73.png";